export const meta: BlockMeta = {
  title: "Gallery",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { ParallaxCarousel } from "@components/media/ParallaxCarousel"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/gallery", (props) => {
  const images = (props.images || []).map((image) => ({
    srcSet: image?.srcSet!,
    aspect: image?.aspect!,
  }))

  return (
    <div className={cn(props.wide ? "w-full px-4" : "grid-auto my-4")}>
      <div className={cn("col-span-12", props.wide ? "" : "md:col-span-8 md:col-start-3")}>
        <ParallaxCarousel
          className={cn(props.wide ? "h-galleryH" : "h-galleryHSlim")}
          images={images}
          inactiveWidth={props.parallax ? undefined : 1}
        />
      </div>
    </div>
  )
})
